import axios from 'axios';
import CryptoJS from "crypto-js";
import { getSecureItem, setSecureItem } from "../utils/secureStorage";

const API_URL = process.env.REACT_APP_API_URL || 'https://api.bookmyaudition.com/api';
// const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';
const PUBLIC_KEY = 'eyJpZCI6InN5c3RlbV9qb2dldF91c2VyIiwiam9nZXRfdXNlcl9pZCI6ImFub25fc3lzdGVtX3VzZXJfdXVpZCIsInJvbGUiOiJhbm9ueW1vdXMiLCJpYXQiOjE3MDY3NzQ0MDAsImV4cCI6MTcwNjc3ODAwMH0.53d955944702473ba5e682498148c0b5'; // Use process.env.REACT_APP_PUBLIC_API_KEY in a real app

const api = axios.create({ 
    baseURL: API_URL,
    headers: {
        "Content-Type": "application/json",
        'x-api-key': PUBLIC_KEY 
    }
});

const getToken = () => localStorage.getItem('authToken');

api.interceptors.request.use(
    (config) => {
        const token = getToken();
        const Admintoken = localStorage.getItem('adminToken');
        if (token) config.headers.Authorization = `Bearer ${token}`;
        if (Admintoken) config.headers.Authorization = `Bearer ${Admintoken}`;
        return config;
    },
    (error) => Promise.reject(error)
);



// ==========================
// 🔐 CRYPTO SETUP
// ==========================
const SECRET = process.env.REACT_APP_CRYPTO_SECRET;

const key = CryptoJS.SHA256(SECRET);
const iv = CryptoJS.enc.Hex.parse("00000000000000000000000000000000");

// 🔓 DECRYPT FUNCTION
const decrypt = (payload) => {
  const bytes = CryptoJS.AES.decrypt(payload.data, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return bytes.toString(CryptoJS.enc.Utf8);
};

// ==========================
// 🔐 REQUEST INTERCEPTOR
// ==========================
api.interceptors.request.use(
  (config) => {
    // ✅ Correct token handling
    if (config.url.startsWith("/admin")) {
      const adminToken = localStorage.getItem("adminToken");
      if (adminToken) {
        config.headers.Authorization = `Bearer ${adminToken}`;
      }
    } else {
      const userToken = localStorage.getItem("authToken");
      if (userToken) {
        config.headers.Authorization = `Bearer ${userToken}`;
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// ==========================
// 🔐 RESPONSE INTERCEPTOR (IMPORTANT)
// ==========================

api.interceptors.response.use(
  (response) => {
    try {
      // ✅ CASE 1: Body encrypted (NEW SYSTEM)
      if (response.data?.encrypted === true && response.data?.data) {
        const decrypted = decrypt(response.data.data);
        response.data = JSON.parse(decrypted);
        return response;
      }

      // ✅ CASE 2: Header encrypted (OLD SYSTEM)
      const encryptedHeader = response.headers["x-encrypted-data"];
      if (encryptedHeader) {
        const parsed =
          typeof encryptedHeader === "string"
            ? JSON.parse(encryptedHeader)
            : encryptedHeader;

        const decrypted = decrypt(parsed);
        response.data = JSON.parse(decrypted);
        return response;
      }

      // ✅ CASE 3: Normal response (LOOKUP API)
      return response;

    } catch (err) {
      console.error("❌ DECRYPT FAILED:", err);
      return response;
    }
  },
  (error) => Promise.reject(error)
);

// export const fetchLookupDataApi = (groupName) => api.get(`/lookups/public/${encodeURIComponent(groupName)}`);

export const fetchLookupDataApi = async (groupName) => {
  try {
    const storageKey = `lookup_${groupName}`;

    // ✅ 1. LOCAL STORAGE CHECK
    const cached = getSecureItem(storageKey);
    if (cached) {
      console.log("⚡ From localStorage:", groupName);
      return { data: cached };
    }

    // ✅ 2. API CALL
    const res = await api.get(`/lookups/public/${encodeURIComponent(groupName)}`);

    const lookupData = res.data;

    // ✅ 3. SAVE ENCRYPTED
    setSecureItem(storageKey, lookupData);

    return { data: lookupData };

  } catch (err) {
    console.error("❌ Lookup error:", err);
    return { data: [] };
  }
};
